import { Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-questionInf-most-least',
  templateUrl: './question-inf-most-least.component.html',
  styleUrls: ['./question-inf-most-least.component.scss']
})
export class QuestionInfMostLeastComponent implements OnInit {
  @Input() informantForm: FormGroup;
  @Input() isEditValue: boolean;
  @Input() questionIndex: number;

  @Output() media = new EventEmitter();
  @Output() qMedia = new EventEmitter();
  @Output() qMediaType = new EventEmitter();

  @Output() sendArr = new EventEmitter();

  modalData: any;
  choicesMedia = [];
  questionMediaType: string;
  questionMedia;
  vdoDuration;

  informantArray: any[] = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    console.log(this.modalData);
    if (!this.isEditValue) {
      this.modalData.informant_tag.forEach(e => {
        this.informantArray.push({
          tag: e,
          type: 'most/least',
          question: '',
          most: '',
          least: '',
          media: {
            media_type: '',
            file_name: '',
            time_again: '',
            unlimit: '',
            duration: '',
            vdo_id: '',
            file_url: ''
          },
          choices: [],
        })
      });
    } else {
      let val_informant = JSON.parse(this.modalData.value.VALUE_INFORMANT);
      val_informant.splice(0, 1);
      this.informantArray = val_informant;

      this.questionMediaType = this.modalData.value.VALUE[0].media.media_type;

      for (let i = 0; i < this.modalData.value.VALUE[0].choices.length; i++) {
        this.informantFormArray.push(
          this.fb.group({
            choice_id: [this.modalData.value.VALUE[0].choices[i].choice_id, Validators.required],
            choice_detail: [this.modalData.value.VALUE[0].choices[i].choice_detail, Validators.required]
          })
        )
        this.informantForm.controls['media'].setValue(this.modalData.value.VALUE[0].media);

      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes.questionIndex) {
      // ดำเนินการอัปเดตตามต้องการที่นี่
      this.questionIndex = parseInt(changes.questionIndex.currentValue);
    }
  }

  get informantFormArray(): FormArray {
    return this.informantForm.get('choices') as FormArray;
  }

  addChoice(form) {
    form.push(
      this.fb.group({
        choice_id: form.value.length + 1,
        choice_detail: ['', Validators.required]
      })
    );
    console.log(this.informantArray.length);
    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      console.log(i);
      this.copyAddChoiceAndImg(inf, form.value.length, i);
    }

    console.log(this.informantArray);
    console.log(this.informantForm.value);
  }

  copyAddChoiceAndImg(inf, choice_id, index) {
    console.log(index, inf);
    let obj = {
      choice_id: choice_id,
      choice_detail: '',
    }

    inf.choices.push(obj);
    console.log(index, inf.choices.length)
  }

  deleteChoice(form, index) {
    form.removeAt(index);

    form.value.map((f, index) => {
      f.choice_id = index + 1;
    })

    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      this.deleteInformantChoice(inf, index);
    }

    console.log(this.informantArray);
  }

  deleteInformantChoice(inf, index) {
    inf.choices.splice(index, 1);
    inf.choices.map((el, index) => el.choice_id = index + 1)
  }

  setQuestionInformant(value) {
    this.informantArray.forEach((el, i) => {
      if (!el.question) {
        console.log(el)
        el.question = value.question;
      }
      if (!el.most) {
        console.log(el)
        el.most = value.most;
      }
      if (!el.least) {
        console.log(el)
        el.least = value.least;
      }
    });
  }

  setChoiceInformant(choice, index) {
    this.informantArray.forEach((el, i) => {
      if (!el.choices[index].choice_detail) {
        el.choices[index].choice_detail = choice;
      }
    });
  }

  getDuration(e) {
    var video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      this.vdoDuration = video.duration;
      // alert("Duration : " + video.duration + " seconds");
    }
    video.src = URL.createObjectURL(e.target.files[0]);
  }

  addQuestionMedia(e, form) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);
    this.questionMediaType = fileType;

    if (fileType === 'mp4') {
      this.getDuration(e);
    }

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg' || fileType === 'mp3' || fileType === 'mp4' || fileType === 'wav') {
      setTimeout(() => {
        if (e.target.files && e.target.files[0]) {
          const file = (e.target as HTMLInputElement).files[0];
          const type = (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') ? 'image' : (fileType === 'mp3' || fileType === 'wav') ? 'sound' : 'vdo'

          form.controls['media'].patchValue({
            media_type: type,
            file_name: file.name,
            unlimit: '',
            time_again: '',
            duration: this.vdoDuration,
            vdo_id: '',
            file_url: ''
          });

          for (let i = 0; i < this.informantArray.length; i++) {
            const inf = this.informantArray[i];
            inf.media.media_type = type;
            inf.media.file_name = file.name;
            inf.media.unlimit = '';
            inf.media.time_again = '';
            inf.media.duration = this.vdoDuration;
            inf.media.vdo_id = '';
            inf.media.file_url = '';
          }

          form.controls['media'].updateValueAndValidity();
          this.questionMedia = file;
          this.qMedia.emit(this.questionMedia);
          this.qMediaType.emit(this.questionMediaType);
        }
      }, 1000);
    } else {
      alert('การอัปโหลดรองรับไฟล์ JPG, JPEG, PNG, MP3, MP4, WAV เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
    this.copyArr();
  }

  deleteImgQuestion(form) {
    this.questionMedia = '';
    this.questionMediaType = '';

    form.get('media').reset({
      media_type: '',
      file_name: '',
      time_again: '',
      unlimit: '',
      file_url: ''
    });

    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      inf.media.media_type = '';
      inf.media.file_name = '';
      inf.media.time_again = '';
      inf.media.unlimit = '';
      inf.media.file_url = '';
    }
    this.qMedia.emit(this.questionMedia);
    this.qMediaType.emit(this.questionMediaType);
    this.copyArr();
  }

  copyArr() {
    console.log(this.informantArray);
    this.sendArr.emit(this.informantArray);
  }

  clearValueDate(form, unlimit) {
    console.log(form, unlimit);
    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      inf.media.unlimit = unlimit;
    }

    if (!form.value.media.unlimit) {
      form.get('media').patchValue({ time_again: '' });

      for (let i = 0; i < this.informantArray.length; i++) {
        const inf = this.informantArray[i];
        inf.media.time_again = '';
      }
    }

    console.log(form);
    console.log(this.informantArray);
  }

  setTimeAgain(form, e) {
    if (e.target.value > 0) {
      form.get('media').patchValue({ time_again: e.target.value });

      for (let i = 0; i < this.informantArray.length; i++) {
        const inf = this.informantArray[i];
        inf.media.time_again = e.target.value;
      }
    } else {
      form.get('media').patchValue({ time_again: 0 });
      for (let i = 0; i < this.informantArray.length; i++) {
        const inf = this.informantArray[i];
        inf.media.time_again = 0;
      }
    }
  }

}
